export { default as Header } from './Header';
export { default as HeaderText } from './HeaderText';
export { default as Footer } from './Footer';

const stdPadding = 20;
const stdMargin = 20;

export { stdMargin, stdPadding };
